const state = {
  from: "",
  to: "",
  selectFilters: {},
};

const mutations = {
  resetSelectFilters(state) {
    state.selectFilters = {};
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
